// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FoyLH","importantInfo":"styles_importantInfo__37N1n"};